import Vue from 'vue';
import updateHighlightsAndKL from '../util/density/updateHighlightsAndKL';

/* 
  Current understanding:
  Compile runs the whole tree again and recalculates every piece
  Each change triggers (changed input parameters, adding a node to the editor, ) a recompilation
*/

const compile = async ({ engine, editor }) => {

  // console.log('----- Compile was triggered. --------');

  // Empty the KL Divergence array and nodeData object before compiling
  Vue.prototype.$globalSharedData.klDivergenceArray = [];
  Vue.prototype.$globalSharedData.globalNodeData = {};       // object
  
  /*********************************************************************************************
    Why do we need to abort?
    ------------------------
    "Nodes' worker can be async, therefore process() is async.
    And formally, you can call the process again, without waiting for the previous done, 
    but this will lead to conflict. Therefore, you must cancel the processing of the previous."
  **********************************************************************************************/
  await engine.abort();
  await engine.process(editor.toJSON());

  // Calculate density and highlight density, compute KL divergences, update highlights
  updateHighlightsAndKL();

  // console.log('globalNodeData', Vue.prototype.$globalSharedData.globalNodeData);

}

export default compile;
